<template>
	<img
		:src="placeholder"
		:data-src="fixedSize ? $image(media.src, fixedSize) : $image(media.src)"
		:data-srcset="fixedSize ? '' : srcset"
		data-sizes="auto"
		class="vimg lazyload"
		:class="customClass"
		:alt="media.alt || $attrs.alt || 'Image'"
		@lazyloaded="$emit('loaded')"/>
</template>

<script>
export default {
	name: 'VImg',

	props: {
		media: {
			type: Object,
			required: true,
		},
		fixedSize: {
			type: String,
			required: false,
		},
		customClass: {
			type: Object,
			required: false,
		},
	},

	computed: {
		srcset() {
			if (this.fixedSize) return null;

			let srcset = `${this.$image(this.media.src, '200x')} 100w`;

			this.media.width >= 200
				? (srcset += `, ${this.$image(this.media.src, '400x')} 200w`)
				: '';
			this.media.width >= 400
				? (srcset += `, ${this.$image(this.media.src, '800x')} 400w`)
				: '';
			this.media.width >= 600
				? (srcset += `, ${this.$image(this.media.src, '1200x')} 600w`)
				: '';
			this.media.width >= 800
				? (srcset += `, ${this.$image(this.media.src, '1600x')} 800w`)
				: '';
			this.media.width >= 1000
				? (srcset += `, ${this.$image(this.media.src, '2000x')} 1000w`)
				: '';
			this.media.width >= 1500
				? (srcset += `, ${this.$image(this.media.src, '3000x')} 1500w`)
				: '';
			this.media.width >= 2000
				? (srcset += `, ${this.$image(this.media.src, '4000x')} 2000w`)
				: '';

			return srcset;
		},
		placeholder() {
			const w = this.media.width;
			const h = this.media.height;

			if (!w || !h) return '';
			return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"%3E%3C/svg%3E`;
		},
	},
};
</script>

<style scoped>
.vimg {
	background-image: var(--placeholder);
	background-color: var(--offwhite);
	background-repeat: no-repeat;
	background-size: 45%;
	background-position: center;
}

.lazyloaded:not(.remove-transition) {
	transition: background-color 0.275s;
	background-color: transparent;
	background-image: none;
}
</style>
